import { IoDocumentOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import { sendProposalAsync } from "../../../services/accountService";
import Toaster from "./../../../components/common/Toaster";

const ProposalForm = ({ data, isLoading, setLoading, onSuccess }) => {
  const handleSendProposal = async (id) => {
    try {
      setLoading(true);

      await sendProposalAsync(id);
      onSuccess();
      Toaster.Success("Proposal Sent Successfully!");

      setLoading(false);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setLoading(false);
    }
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-center mb-6">
        <div>
          <IoDocumentOutline className="mx-auto text-5xl text-gray-300 mb-6" />
          <p className="text-gray-400 text-sm">
            Send proposal to
            <span className="mx-1 text-blue-400">
              Dr. {data.first_name} {data.last_name}
            </span>
            ?
          </p>
        </div>
      </div>
      <button
        type="submit"
        className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
        onClick={() => handleSendProposal(data.id)}
        disabled={isLoading}
      >
        {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
        Yes, send it via email
      </button>
    </div>
  );
};

export default ProposalForm;
